import { AccountCertData, IAccountCertData } from './types';

enum Action {
  GET_SERT = 'toggleStatement',
  ACTION_TEXT = 'Заявление на начисление номинала',
}

const accountCertData = (data: IAccountCertData): AccountCertData => {
  return {
    id: data!.id || '',
    childName:
      data!.last_name && data!.first_name
        ? `${data.last_name} ${data.first_name}`
        : 'Без имени',
    fio: data!.fio || '',
    birthday: data.birthday.length
      ? data.birthday.split('-').reverse().join('.')
      : '',
    isAccountType: true,
    certificateType: data!.certificate_type,
    certificateNumber: data!.certificate_number,
    toIssue: data!.certificate_request ? null : data!.toIssue,
    action: Action.GET_SERT,
    actionText: data!.certificate_request ? '' : Action.ACTION_TEXT,
    certificateId: data!.certificate_id,
  };
};

export default accountCertData;



// WEBPACK FOOTER //
// ./src/services/pfdod/utils/accountCertData.ts